export default __webpack_public_path__ + "static/Journey-of-pepperclude-a0c961646fa8c7747087c8debfcb92db.svg";